import { InscriptionService } from '@modules/inscription/inscription-service';
import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';

const amount = {
    paid: {
        amount: 190,
        currency: 'usd'
    },
    pending: {
        amount: 0,
        currency: 'usd'
    },
};

export default {
    namespaced: true,

    state: {
        loading: false,
        record: null,
        amount: amount,
    },

    getters: {
        record: (state) => state.record,
        loading: (state) => !!state.loading,
        amount: (state) => state.amount,
    },

    mutations: {
        FIND_STARTED(state) {
            state.record = null;
            state.loading = true;
        },

        FIND_SUCCESS(state, payload) {
            state.record = payload;
            state.loading = false;
        },

        FIND_BALANCE(state, {amount}) {
            state.loading = false;
            state.amount = amount;
        },

        FIND_ERROR(state) {
            state.record = null;
            state.loading = false;
        },
    },

    actions: {
        async doFind({ commit }, id) {
            try {
                commit('FIND_STARTED');
                const record = await InscriptionService.find(id);
                commit('FIND_SUCCESS', record);
            } catch (error) {
                Errors.handle(error);
                commit('FIND_ERROR');
                routerAsync().push('/inscription');
            }
        },
    },
};